<template>
  <div class="profile-dropdown-wrapper">
    <VaDropdown v-model="isShown" :offset="[9, 0]" class="profile-dropdown" stick-to-edges>
      <template #anchor>
        <VaButton preset="secondary" color="textPrimary">
          <span class="profile-dropdown__anchor min-w-max">
            <slot />
            <div v-if="isAuthenticated">
              <div>{{ user?.name }}</div>
            </div>
          </span>
        </VaButton>
      </template>
      <VaDropdownContent
        class="profile-dropdown__content w-full px-0 py-4 md:w-60"
        :style="{ '--hover-color': hoverColor }"
      >
        <VaList v-for="group in options" :key="group.name">
          <header v-if="group.name" class="px-4 text-xs font-bold uppercase text-[var(--va-secondary)] opacity-80">
            {{ `${group.name}` }}
          </header>
          <VaListItem
            v-for="item in group.list"
            :key="item.name"
            class="menu-item h-8 cursor-pointer px-4 text-base"
            v-bind="resolveLinkAttribute(item)"
            @click="item.name === 'logout' ? logout() : null"
          >
            <VaIcon :name="item.icon" class="pr-1" color="secondary" />
            {{ `${item.name}` }}
          </VaListItem>
          <VaListSeparator v-if="group.separator" class="mx-3 my-2" />
        </VaList>
      </VaDropdownContent>
    </VaDropdown>
  </div>
</template>
<script lang="ts" setup>
import { useAuth } from "@/auth/composables/useAuth";
import { ref, computed, onMounted } from "vue";
import { useColors } from "vuestic-ui";

const { colors, setHSLAColor } = useColors();
const hoverColor = computed(() => setHSLAColor(colors.focus, { a: 0.1 }));
const { fetchCurrentUser, isAuthenticated, user, logout } = useAuth();

onMounted(async () => {
  await fetchCurrentUser();
});

type ProfileListItem = {
  name: string;
  to?: string;
  href?: string;
  icon: string;
};

type ProfileOptions = {
  name: string;
  separator: boolean;
  list: ProfileListItem[];
};

withDefaults(
  defineProps<{
    options?: ProfileOptions[];
  }>(),
  {
    options: () => [
      {
        name: "account",
        separator: false,
        list: [
          {
            name: "logout",
            icon: "mso-logout",
          },
        ],
      },
    ],
  },
);

const isShown = ref(false);

const resolveLinkAttribute = (item: ProfileListItem) => {
  return item.to ? { to: { name: item.to } } : item.href ? { href: item.href, target: "_blank" } : {};
};
</script>
<style lang="scss">
.profile-dropdown {
  cursor: pointer;

  &__content {
    .menu-item:hover {
      background: var(--hover-color);
    }
  }

  &__anchor {
    display: inline-block;
  }
}
</style>
